import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { brandFontSize } from "../../utils/variables";

export const SidebarItem = ({
  path,
  onClick,
  text,
  icon,
  activeIcon,
  childs,
  isShow,
  isShowClient,
  isShowCustomer,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const normalizePath = (p) => (p.startsWith("/") ? p : `/${p}`);
  const isActive = childs
    ? childs.some((c) =>
        location.pathname.startsWith(normalizePath(path) + "/" + c.path.split("/:")[0]),
      )
    : location.pathname.startsWith(normalizePath(path.split("/:")[0]));

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const dropdownRef = useRef(null);
  const itemRef = useRef(null);
  const { authRole } = useAuth();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      itemRef.current &&
      !itemRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
      setTimeout(() => setIsVisible(false), 300); // Match this duration with the CSS transition duration
    }
  };

  const handleItemClick = (e) => {
    if (childs && !isSingleChild) {
      e.preventDefault();
      if (isDropdownOpen) {
        setIsDropdownOpen(false);
        setTimeout(() => setIsVisible(false), 300); // Match this duration with the CSS transition duration
      } else {
        setIsVisible(true);
        setTimeout(() => setIsDropdownOpen(true), 10);
      }
    }
  };

  const handleChildItemClick = (parentPath, childPath) => {
    const absolutePath = parentPath + "/" + childPath;
    navigate(absolutePath);
    setIsVisible(false);
    setIsDropdownOpen(false);
  };

  const shouldShowItem =
    (isShow && isShowClient == true && authRole === "CLIENT") ||
    (isShow && isShowClient == false && isShowCustomer !== false && authRole === "CUSTOMER") ||
    (isShow && isShowCustomer == true && authRole === "CUSTOMER") ||
    (isShow && isShowClient == false && authRole === "FREELANCER") ||
    (isShow && isShowClient == true && authRole === "ADMIN");

  const isChildVisible = (child) =>
    authRole === "CUSTOMER" ? !!child?.isShowCustomer : !!child?.isShowClient;

  const visibleChilds = childs?.filter(isChildVisible) || [];
  const childsLength = visibleChilds.length;

  const isSingleChild = authRole === "CUSTOMER" && !!childs && childsLength === 1;
  const directChildPath = isSingleChild ? normalizePath(path) + "/" + visibleChilds[0].path : null;

  return (
    <>
      {shouldShowItem && (
        <div className="relative" ref={dropdownRef}>
          <div ref={itemRef}>
            <Link className="" to={directChildPath || path} onClick={onClick}>
              <div
                className="flex flex-col justify-center items-center py-3 border-b border-zinc-300"
                onClick={handleItemClick}
              >
                {isActive ? activeIcon : icon}
                <p className={`  text-[${brandFontSize}] ${isActive && "text-primary"}`}>{text}</p>
              </div>
            </Link>
          </div>
          {childs && !isSingleChild && isVisible && (
            <div
              className={`absolute top-2 left-[86px] bg-white  rounded-lg w-52 shadow-lg py-1 px-2 transition-all duration-300 ease-in-out transform ${
                isDropdownOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
              }`}
              ref={dropdownRef}
            >
              {childs.map((child, index) => (
                <>
                  {isChildVisible(child) && (
                    <div
                      onClick={() => handleChildItemClick(path, child.path)}
                      key={index}
                      className={`cursor-pointer border-zinc-300 py-3 px-4 ${
                        childsLength - 1 === index ? "" : "border-b"
                      }
                   
                  
                  `}
                    >
                      <p
                        className={`text-sm ${
                          location.pathname.includes(child.path) ? "text-primary" : ""
                        }`}
                      >
                        {child.text}
                      </p>
                    </div>
                  )}
                </>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};
